var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(0 -55.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496",
    transform: "translate(17.319 68.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5006",
    "data-name": "Trazado 5006",
    d: "M279.524,258.569a2.281,2.281,0,0,0-2.562,0,2.255,2.255,0,0,0-1.278-.392,2.287,2.287,0,0,0,0,4.574,2.255,2.255,0,0,0,1.278-.392,2.287,2.287,0,0,0,2.562-3.79Zm-.513,2.556a1.014,1.014,0,0,1-1.43.127.883.883,0,0,1-.133-.133.611.611,0,0,0-.487-.221.628.628,0,0,0-.487.228.99.99,0,0,1-.785.367,1.023,1.023,0,0,1-1.025-1.019,1.016,1.016,0,0,1,1.8-.652.634.634,0,0,0,.892.095.672.672,0,0,0,.095-.095,1.015,1.015,0,1,1,1.556,1.3Z",
    transform: "translate(-273.4 -258.175)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498",
    transform: "translate(0 55.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_497",
    "data-name": "Grupo 497",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5007",
    "data-name": "Trazado 5007",
    d: "M26.974,63.073c0-.057.025-.12.025-.184s-.025-.12-.025-.177V61.358a2.694,2.694,0,0,0-2.71-2.677h-.773v-.766A2.694,2.694,0,0,0,20.819,55.2H2.684A2.7,2.7,0,0,0,0,57.915V69.042a2.672,2.672,0,0,0,2.666,2.677h.754v.766a2.721,2.721,0,0,0,2.7,2.715H24.264a2.73,2.73,0,0,0,2.71-2.715V66.042c0-.057.025-.12.025-.177s-.025-.12-.025-.177ZM3.419,61.358v9.095H2.684a1.405,1.405,0,0,1-1.418-1.386V57.915a1.439,1.439,0,0,1,1.418-1.449H20.826a1.428,1.428,0,0,1,1.406,1.449v.766H6.123A2.688,2.688,0,0,0,3.419,61.358ZM25.708,72.485a1.456,1.456,0,0,1-1.444,1.449H6.123a1.447,1.447,0,0,1-1.437-1.449V66.466H25.708Zm0-7.285H4.685V63.554H25.708Zm.006-2.911H4.685v-.93a1.423,1.423,0,0,1,1.437-1.411H24.27a1.424,1.424,0,0,1,1.444,1.411Z",
    transform: "translate(0 -55.2)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.12f14ea05ec8ffda57b8392d88db9c2d.svg";
export { ForwardRef as ReactComponent };